import React from "react";

const LoadingPage = () => {
  return (
    <div className="container">
      <div className="row auth-loading-shell">
        <div className="auth-loading-card">
          <div className="auth-loading-spinner" aria-hidden="true"></div>
          <div className="auth-loading-title">Loading...</div>
          <div className="auth-loading-subtitle">Checking your session</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
